module.exports = __webpack_public_path__ + "static/media/yelpcamp1.1fb4163a.jpg";